import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import QueryMember from "./pages/query-member";
import Report from "./pages/report";
import CancelPurchase from "./pages/cancel-purchase";
import AuthManager from "./core/oidc";
import NotFound from "./pages/shared/not-found";
import Layout from "./pages/shared/layout/Layout";
import Login from "./pages/shared/login";
import LoginCallback from "./pages/shared/login-callback";
import LoggedOut from "./pages/shared/logged-out";
import Logout from "./pages/shared/logout";
import LayoutPrivate from "./pages/shared/layout/LayoutPrivate";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import MvkReservationInfoComponent from "./pages/mvk-reservation/mvk-reservation-info";
import { ElementType, useEffect, useState } from "react";
import ReportMvkReservationComponent from "./pages/mvk-reservation/report-mvk-reservation";

interface RequireAuthProps {
  children: JSX.Element;
  redirectTo?: string
}

interface MainPageProps {
  redirectTo?: string
}

const RequireAuth = (props: RequireAuthProps) => {
  const isLoggedIn = AuthManager.isLoggedIn();

  if (isLoggedIn) {
    sessionStorage.setItem("returnUrl", window.location.pathname);
    return props.children;
  }

  return <Navigate to={props.redirectTo ?? '/login'} />;
}

const MainPage = (props: MainPageProps) => {
  const isLoggedIn = AuthManager.isLoggedIn();

  if (isLoggedIn) {
    sessionStorage.setItem("returnUrl", window.location.pathname);
    const Page = AuthManager.getMainPage();
    return <Page />;
  }

  return <Navigate to={props.redirectTo ?? '/login'} />;
};

const ErrorBoundary = () => {

  const error = useRouteError();

  console.log('route error', error);

  if (isRouteErrorResponse(error)) {

    if (error.status === 404) {
      return <NotFound />;
    }

    if (error.status === 401) {
      return <div>You aren't authorized to see this</div>;
    }

    if (error.status === 503) {
      return <div>Looks like our API is down</div>;
    }
  }

  return <div>Something went wrong</div>;
}

const App = () => {
  const theme = createTheme({
    typography: {
      fontFamily: '"Cabin", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route errorElement={<ErrorBoundary />}>
            <Route path="login" element={<Layout><Login /></Layout>} />
            <Route path="logged-out" element={<Layout><LoggedOut /></Layout>} />
            <Route path="callback" element={<Layout><LoginCallback /></Layout>} />
            <Route path="logout" element={<Layout><Logout /></Layout>} />
            <Route element={<LayoutPrivate />}>
              <Route path="/" element={<MainPage />} />
              <Route path="uye-sorgula" element={<RequireAuth><QueryMember /></RequireAuth>} />
              <Route path="alisveris-iptal" element={<RequireAuth><CancelPurchase /></RequireAuth>} />
              <Route path="raporlama" element={<RequireAuth><Report /></RequireAuth>} />
              <Route path="mvk-reservation-info" element={<RequireAuth><MvkReservationInfoComponent /></RequireAuth>} />
              <Route path="report-mvk-reservation" element={<RequireAuth><ReportMvkReservationComponent /></RequireAuth>} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* <LayoutRoute path={["/", "/uye-sorgula"]} exact component={QueryMember} />
        <LayoutRoute path="/alisveris-iptal" exact component={CancelPurchase} />
        <LayoutRoute path="/raporlama" exact component={Report} /> */}
          {/* <LayoutPublicRoute path="/login" exact component={Login} />
        <LayoutPublicRoute path="/logged-out" exact component={Logout} />
        <LayoutPublicRoute path="/callback" component={LoginCallback} /> */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
